import NavbarMobile from "../../navbar/components/NavbarMobile";

// Corregí el uso de children: se usa {children} directamente en lugar de <Children/>
// porque children es un nodo React, no un componente.
export default function LayoutMobile({children}) {
  const DEBUG = process.env.NODE_ENV === 'development';

  return (
    <div className='h-screen overflow-auto bg-neutral-900'>
      {/* {DEBUG && <div className='text-white text-center bg-red-900'>mobile</div>} */}
      {children}
      <NavbarMobile/>
    </div>
  )
}